export function matchSubdomainForSSO(href: string) {
  const currentUrl = new URL(href);
  const subdomain = currentUrl.host.substring(0, currentUrl.host.indexOf('.acmeticketing.')).trim();

  return matchNaraSubdomain(subdomain) || matchAcmeSubdomain(subdomain);
}

function matchNaraSubdomain(subdomain: string) {
  const naraRegex = /backoffice-(\w+)-(narasand1|nara)/;
  const routingSubdomain = naraRegex.exec(subdomain)?.[1];

  return routingSubdomain ?? '';
}

function matchAcmeSubdomain(subdomain: string) {
  const subdomainRegex = /(sand\d+-)?backoffice-(\w+)/;
  const routingSubdomain = subdomainRegex.exec(subdomain)?.[2];

  return routingSubdomain ?? '';
}
